import { Injectable } from '@angular/core';
import { Endpoints } from 'src/environments/endpoints';
import { CreditValidation, CreditValidationResponse } from '../model/http/creditResponse.model';
import { ConsumeService } from './consume.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CreditService {

  constructor(private consumeService: ConsumeService) { }

  validCredit(cardCode: string, needAmountValidation: boolean, amountValue: number): Observable<CreditValidationResponse> {
    return this.consumeService.httpGet<CreditValidationResponse>(`${Endpoints.credit.validation}?cardcode=${cardCode}&needamountvalidation=${needAmountValidation}&amountvalue=${amountValue}`);
  }

  validateUserDoesNotHavePendingInvoices(params: string): Observable<CreditValidationResponse>{
    return this.consumeService.httpGet<CreditValidationResponse>(`${Endpoints.credit.validation}${params}`);
  }
}
